<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <div class="row mb-10">
          <div class="col-md-4">
            <h4 class="heading semi-bold">Box Management</h4>
          </div>
          <div class="col-md-8 text-right">
            <button
              class="btn btn-primary"
              @click="addBox()"
              v-if="!isReadOnlyUser"
            >
              <i class="fa fa-plus-circle" aria-hidden="true"></i> Add Box
            </button>
          </div>
        </div>
      </div>
      <div class="grid-body">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>#</th>
              <th class="pointer" @click="sort('box_number')">
                Box Number &nbsp;<i class="fa fa-sort"></i>
              </th>
              <th class="pointer" @click="sort('size')">
                Box Size &nbsp;<i class="fa fa-sort"></i>
              </th>
              <th class="text-center pointer" @click="sortByCurrentShirt()">
                Total Shirts In This Box &nbsp;<i class="fa fa-sort"></i>
              </th>
              <th v-if="!isReadOnlyUser">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(box, index) in boxes" :key="box.id">
              <td>{{ index + 1 }}.</td>
              <td>
                <input
                  type="text"
                  v-model="box.box_number"
                  class="form-control"
                />
              </td>
              <td>
                <input type="number" v-model="box.size" class="form-control" />
              </td>
              <td class="text-center">
                <span v-if="box.shirts > 0">
                  <span class="badge badge-success"> {{ box.shirts }}</span>
                  <br />
                  <span v-if="box.shirts_with_carton > 0">
                    (In Packaging)
                  </span>
                </span>
                <span v-else class="badge badge-info"> Empty </span>
              </td>
              <td v-if="!isReadOnlyUser">
                <button
                  class="btn btn-primary"
                  v-if="box.id"
                  @click="updateBox(index)"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i> Update
                </button>
                <button
                  class="btn btn-primary"
                  v-else
                  @click="createBox(index)"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i> Create
                </button>
                <button class="btn btn-danger" @click="deleteBox(index)">
                  <i class="fa fa-trash" aria-hidden="true"></i> Remove
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import alasql from "alasql";
export default {
  data() {
    return {
      boxes: [],
      sortColumn: "box_number",
      sortBy: "asc",
      isReadOnlyUser: false,
    };
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.getBoxes();
  },
  methods: {
    async getBoxes() {
      let res = await axios.get("packaging/boxes", {
        params: { sort: this.sortBy, column: this.sortColumn },
      });
      if (res) {
        let boxes = res.data;
        if (boxes.length < 1) {
          this.boxes = [{ id: null, box_number: null, size: 0 }];
        } else {
          this.boxes = boxes;
        }
      }
    },

    sort(column) {
      this.sortColumn = column;
      if (this.sortBy == "desc") {
        this.sortBy = "asc";
      } else {
        this.sortBy = "desc";
      }
      this.getBoxes();
    },

    addBox() {
      this.boxes.unshift({ id: null, box_number: null, size: 0 });
    },

    async updateBox(index) {
      let data = this.boxes[index];
      if (data.box_number == "" || data.box_number == null) {
        toastr.error("Please Write Box Number");
        return false;
      }
      if (this.checkSameBoxExit(data.box_number)) {
        toastr.error("Same Box Exit");
        return false;
      }
      let res = await axios.put("packaging/boxes/" + data.id, data);
      if (res) {
        this.boxes[index].shirts = res.data.shirts;
      }
      toastr.success("SUCCESS");
    },

    async deleteBox(index) {
      let result = await Swal.fire({
        title: "Are you sure to Delete?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "NO",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "YES",
      });
      if (result.value) {
        let data = this.boxes[index];
        let res = await axios.delete("packaging/boxes/" + data.id);
        if (res) {
          this.boxes.splice(index, 1);
          toastr.success("SUCCESS");
        }
      }
    },

    async createBox(index) {
      let data = this.boxes[index];
      if (data.box_number == "" || data.box_number == null) {
        toastr.error("Please Write Box Number");
        return false;
      }
      if (this.checkSameBoxExit(data.box_number)) {
        toastr.error("Same Box Exit");
        return false;
      }
      try {
        let res = await axios.post("packaging/boxes", data);
        if (res) {
          this.boxes[index].id = res.data.id;
          this.boxes[index].shirts = res.data.shirts;
          toastr.success("SUCCESS");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    checkSameBoxExit(box_number) {
      var res = alasql(`SELECT * FROM ? where box_number = '${box_number}' `, [
        this.boxes,
      ]);
      if (res.length > 1) {
        return true;
      }
      return false;
    },

    sortByCurrentShirt() {
      if (this.sortBy == "desc") {
        this.sortBy = "asc";
      } else {
        this.sortBy = "desc";
      }
      let sortedArray = _.orderBy(
        this.boxes,
        ["shirts", "shirts_with_carton"],
        [this.sortBy, this.sortBy]
      );
      this.boxes = sortedArray;
    },
  },
};
</script>
<style>
.grid-title h4 {
  margin-top: 7px;
}
.table-bordered th {
  background-color: var(--primary-color);
  color: white;
  border: 0 !important;
}
</style>
